/**
 * Controller: ReportsPrintLoadingModal
 */
angular.module('acme.view.application.reports.print.loadingModal.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers'
])
.controller('ReportsPrintLoadingModalController', [ '$scope', '$sce', '$timeout', '$uibModalInstance', 'HelpersService', 'report', 'runDate', 'retrys', function ($scope, $sce, $timeout, $uibModalInstance, HelpersService, report, runDate, retrys) {

    $scope.errors = [];

    $scope.model = {};
    $scope.progress = 0;
    $scope.retrys = 0;
    $scope.retryMax = 2;
    $scope.showRetry = false;
    $scope.showDone = false;
    $scope.dateFormats = HelpersService.dateFormats;
    $scope.progressType = 'info';
    $scope.progressTypes = ['info', 'warning', 'danger', 'success'];

    $scope.init = function() {

      if (report) {
        $scope.model = report;
      }

      if (runDate) {
        $scope.model.runDate = runDate;
      }

      if (retrys) {
        $scope.retrys = retrys;
      }

      $scope.$on('ReportsPrintController::Error', function(e, data) {
        $scope.errors = [{
          message: data.error || 'An unknown error has occurred'
        }];
      });

      $scope.$on('ReportsPrintController::Progress', function(e, data) {

        $scope.progress = data.progress;
        $scope.showRetry = false;

        if ($scope.progress === 100) {
          $timeout(function () {
            if ($scope.hasErrors()) {
              $scope.showRetry = true;
              $scope.showDone = ($scope.retrys >= $scope.retryMax);
              $scope.progressType = $scope.progressTypes[$scope.retrys];
            } else {
              $scope.progressType = $scope.progressTypes[3];
              $scope.done();
            }
            return true;
          }, 100);
        }

      });
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.retry = function() {
      $scope.success(true);
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function (retry) {
      $uibModalInstance.close(retry);
    };

    $scope.init();

  }]);
